import {IMAGE_HOST} from "../constants";

/** "₦12,500" — Naira formatting used across learner pages. */
export const money = (value) =>
  new Intl.NumberFormat("en-NG", {
    style: "currency",
    currency: "NGN",
    maximumFractionDigits: 0,
  }).format(Number(value) || 0);

/** "16 Sep 2026" (or "" when the value is missing/invalid). */
export const shortDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? ""
    : date.toLocaleDateString(undefined, {year: "numeric", month: "short", day: "numeric"});
};

/** Learner API images are usually relative paths — prefix the API host. */
export const imageUrl = (raw) =>
  !raw
    ? null
    : /^https?:\/\//i.test(raw)
      ? raw
      : `${IMAGE_HOST}${String(raw).startsWith("/") ? "" : "/"}${raw}`;

/** Keep the learner's chosen/cached photo stable; fall back to the API or Google profile. */
export const getLearnerAvatar = (user) => {
  try {
    const savedChoice = window.localStorage.getItem("image");
    if (savedChoice) return savedChoice;
  } catch {
    // Continue to the in-memory/API profile when browser storage is unavailable.
  }
  return user?.avatar || user?.image || user?.picture || user?.profileImage || "";
};

/** Cache a newly supplied learner photo without erasing an existing one on empty auth responses. */
export const saveLearnerAvatar = (userOrUrl) => {
  const url = typeof userOrUrl === "string"
    ? userOrUrl
    : userOrUrl?.avatar || userOrUrl?.image || userOrUrl?.picture || userOrUrl?.profileImage || "";
  if (!url) return;
  try {
    window.localStorage.setItem("image", url);
    window.dispatchEvent(new Event("fillop-profile-updated"));
  } catch {
    /* The server profile remains the source of truth if storage is unavailable. */
  }
};

/** Full name helpers for the single `name` field the learner API returns. */
export const displayName = (user) =>
  user?.name || [user?.first_name, user?.last_name].filter(Boolean).join(" ") || user?.email || "Learner";

export const initialsOf = (user) =>
  displayName(user)
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() || "")
    .join("") || "L";
